/*
 * @Author: xx
 * @Date: 2019-10-29 11:41:10
 * @LastEditTime: 2021-08-13 10:42:19
 * @LastEditors: xx
 * @Description: 请求方法
 * @FilePath: \chen\git-project\test\pilot-oms-operator-front\src\api\require.js
 */
import Vue from "vue";
import axios, { AxiosResponse, AxiosRequestConfig } from "axios";
import common from "../common/common";
import myConfig from "../config/config";
import store from "../store/index";
import { objAny } from "../common/common-interface";
import i18n from "@/config/i18n";
declare type Methods =
  | "GET"
  | "OPTIONS"
  | "HEAD"
  | "POST"
  | "PUT"
  | "DELETE"
  | "TRACE"
  | "CONNECT";
// declare interface Datas {
//   method?: Methods;
//   [key: string]: any;
// }
axios.defaults.timeout = 120000;
axios.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    return config;
  },
  (err: objAny) => {
    return Promise.reject(err);
  }
);
axios.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (err: objAny) => {
    if (err && err.response) {
      return Promise.reject(err.response.data);
    } else {
      err.message = i18n.t("connectionFailure") + "";
      return Promise.reject(err);
    }
  }
);

export const postHeaders = function(data: objAny): objAny {
  const state: any = store.state; // eslint-disable-line
  const loginData: objAny = state.sys.userInfo;
  let headers: objAny = {
    osType: "web",
    "Content-Type": "application/json;charset=UTF-8",
    "Accept-Language": i18n.locale
  };
  if (loginData && loginData.accessToken) {
    headers["access_token"] = loginData.accessToken;
    headers["Authorization"] = "Bearer " + loginData.accessToken;
  }
  if (data) {
    headers = Object.assign(headers, data);
  }

  return headers;
};

export const request = function(
  url: string,
  params: objAny,
  configData?: objAny
) {
  if (url.indexOf("http") === -1 && url.indexOf(myConfig.ajaxHost) === -1) {
    const ajaxHost: string = myConfig.ajaxHost;
    url = ajaxHost + url;
  }

  let config: objAny | number | string;
  let header: objAny = {};
  let method: AxiosRequestConfig["method"] = "POST";
  if (configData) {
    if (configData.config) {
      config = configData.config;
    }
    if (configData.method === "get") {
      url = url + "?" + common.parseParam(params);
      params = {};
      method = "GET";
    } else if (configData.method === "postStr") {
      url = url + "?" + common.parseParam(params);
      params = {};
      method = "POST";
    } else if (configData.method === "getDel") {
      url = url + "?" + common.parseParam(params);
      params = {};
      method = "DELETE";
    } else if (configData.method === "delStr") {
      let srt = "";
      for (const i in params) {
        srt = srt + "/" + params[i];
      }
      url = url + srt;
      params = {};
      method = "DELETE";
    } else if (configData.method === "del") {
      method = "DELETE";
    } else if (configData.method === "formData") {
      // 这个是后面加的,所以看起来有点怪怪
      const paramsForm = new FormData(); // 创建表单
      for (const i in params) {
        paramsForm.append(i, params[i]);// eslint-disable-line
      }
      params = paramsForm;
      method = "POST";
      const formHeaders: objAny = configData.headers || {};
      formHeaders["Content-Type"] = "multipart/form-data";
      configData.headers = formHeaders;
    }
    if (configData.headers) {
      // headers 合并到请求头里面
      header = configData.headers;
    }
  }
  const headers = postHeaders(header);
  if (!headers) {
    return;
  }

  return new Promise<any>((resolve, reject) => {// eslint-disable-line
    const options: AxiosRequestConfig = {
      method: method,
      url: url,
      data: params,
      headers: headers
    };
    axios(options)
      .then(async result => {
        // TODO 逻辑处理

        const successData = result.data;

        if (successData.status === myConfig.apiStatus) {
          resolve(successData);
        } else {
          if (config === "download") {
            if (result.status === 200) {
              resolve(successData);
            } else {
              Vue.prototype.$Notice.error({
                title: i18n.t("tips"),
                desc: successData.msg
              });
            }
          } else {
            Vue.prototype.$Notice.error({
              title: i18n.t("tips"),
              desc: successData.msg
            });
            resolve(successData);
          }
        }
      })
      .catch(async (error: objAny) => {
        if (error.status === 401 || error.status === 4) {
          // const msg = error.code ? error.msg : "登录过期,请重新登录";
          const msg = i18n.t("formText.loginTimeOut") + "";
          Vue.prototype.$Modal.confirm({
            title: i18n.t("tips"),
            content: msg,
            onOk: () => {
              Vue.prototype.$common.out();
            }
          });
        } else {
          console.log(error);
          reject(error);
          Vue.prototype.$Modal.error({
            title: i18n.t("tips"),
            content: error.msg
          });
        }
      });
  });
};
